import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {selectUserInformation} from 'src/modules/profile/user/services/user-profile-slice';
import {getActiveAccountProfileLicense} from 'src/openapi/admin/apis/AccountActiveLicenseApi';
import {useAppDispatch} from 'src/store/hooks';

import type {LicenseShortInfo} from 'src/openapi/admin/models/LicenseShortInfo';

export const useUserLicense = () => {
    const apiDispatch = useAppDispatch();
    const userInformation = useSelector(selectUserInformation);

    const [license, setLicense] = useState<LicenseShortInfo | null>(null);

    useEffect(() => {
        const loadLicense = async (accountId: number) => {
            const activeLicense = await apiDispatch(getActiveAccountProfileLicense({accountId}));

            if (activeLicense.payload.success) {
                setLicense(activeLicense.payload.data);
            }
        };

        if (userInformation?.account?.accountId) {
            loadLicense(userInformation.account.accountId);
        }
    }, [userInformation, apiDispatch]);

    return license ? {...license, accountId: userInformation?.account?.accountId} : null;
};
